import { useContext } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { QuotationAnswerContext } from '@/contexts/QuotationAnswerContext';
import { Button, Box, Typography } from '@mui/material';

interface BuyerButtonProps {
  nbUnreadMessages: number;
}

export default function BuyerButton({ nbUnreadMessages }: BuyerButtonProps) {
  const router = useRouter();
  const { chave } = router.query;
  const { quotationAnswer } = useContext(QuotationAnswerContext);
  return (
    <Link
      href={`/resposta-cotacoes/${quotationAnswer.id}/mensagens${
        chave ? `?chave=${chave}` : ''
      }`}
      passHref
    >
      <Button
        sx={{
          width: '100%',
          p: 1,
          color: '#000000',
          textTransform: 'none',
          fontWeight: '400',
        }}
      >
        Fale com o comprador(a)
        {nbUnreadMessages > 0 && (
          <Box
            sx={{
              bgcolor: 'red',
              width: 16,
              height: 16,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'absolute',
              right: 25,
              top: 4,
            }}
          >
            <Typography
              data-testid="nbUnreadMessages"
              variant="body2"
              align="center"
              sx={{ color: '#fff', fontWeight: 500, fontSize: '10px' }}
            >
              {nbUnreadMessages > 9 ? '9+' : nbUnreadMessages}
            </Typography>
          </Box>
        )}
      </Button>
    </Link>
  );
}
